export const mapData = {
  '上海': [121.4648, 31.2891],
  '东莞': [113.8953, 22.901],
  '东营': [118.7073, 37.5513],
  '中山': [113.4229, 22.478],
  '临汾': [111.4783, 36.1615],
  '临沂': [118.3118, 35.2936],
  '丹东': [124.541, 40.4242],
  '丽水': [119.5642, 28.1854],
  '乌鲁木齐': [87.9236, 43.5883],
  '佛山': [112.8955, 23.1097],
  '保定': [115.0488, 39.0948],
  '兰州': [103.5901, 36.3043],
  '包头': [110.3467, 41.4899],
  '北京': [116.4551, 40.2539],
  '北海': [109.314, 21.6211],
  '南京': [118.8062, 31.9208],
  '南宁': [108.479, 23.1152],
  '南昌': [116.0046, 28.6633],
  '南通': [121.1023, 32.1625],
  '厦门': [118.1689, 24.6478],
  '台州': [121.1353, 28.6688],
  '合肥': [117.29, 32.0581],
  '呼和浩特': [111.4124, 40.4901],
  '咸阳': [108.4131, 34.8706],
  '哈尔滨': [127.9688, 45.368],
  '唐山': [118.4766, 39.6826],
  '嘉兴': [120.9155, 30.6354],
  '大同': [113.7854, 39.8035],
  '大连': [122.2229, 39.4409],
  '天津': [117.4219, 39.4189],
  '太原': [112.3352, 37.9413],
  '威海': [121.9482, 37.1393],
  '宁波': [121.5967, 29.6466],
  '宝鸡': [107.1826, 34.3433],
  '宿迁': [118.5535, 33.7775],
  '常州': [119.4543, 31.5582],
  '广州': [113.5107, 23.2196],
  '廊坊': [116.521, 39.0509],
  '延安': [109.1052, 36.4252],
  '张家口': [115.1477, 40.8527],
  '徐州': [117.5208, 34.3268],
  '德州': [116.6858, 37.2107],
  '惠州': [114.6204, 23.1647],
  '成都': [103.9526, 30.7617],
  '扬州': [119.4653, 32.8162],
  '承德': [117.5757, 41.4075],
  '拉萨': [91.1865, 30.1465],
  '无锡': [120.3442, 31.5527],
  '日照': [119.2786, 35.5023],
  '昆明': [102.9199, 25.4663],
  '杭州': [119.5313, 29.8773],
  '枣庄': [117.323, 34.8926],
  '柳州': [109.3799, 24.9774],
  '株洲': [113.5327, 27.0319],
  '武汉': [114.3896, 30.6628],
  '汕头': [117.1692, 23.3405],
  '江门': [112.6318, 22.1484],
  '沈阳': [123.1238, 42.1216],
  '沧州': [116.8286, 38.2104],
  '河源': [114.917, 23.9722],
  '泉州': [118.3228, 25.1147],
  '泰安': [117.0264, 36.0516],
  '泰州': [120.0586, 32.5525],
  '济南': [117.1582, 36.8701],
  '济宁': [116.8286, 35.3375],
  '海口': [110.3893, 19.8516],
  '淄博': [118.0371, 36.6064],
  '淮安': [118.927, 33.4039],
  '深圳': [114.5435, 22.5439],
  '清远': [112.9175, 24.3292],
  '温州': [120.498, 27.8119],
  '渭南': [109.7864, 35.0299],
  '湖州': [119.8608, 30.7782],
  '湘潭': [112.5439, 27.7075],
  '滨州': [117.8174, 37.4963],
  '潍坊': [119.0918, 36.524],
  '烟台': [120.7397, 37.5128],
  '玉溪': [101.9312, 23.8898],
  '珠海': [113.7305, 22.1155],
  '盐城': [120.2234, 33.5577],
  '盘锦': [121.9482, 41.0449],
  '石家庄': [114.4995, 38.1006],
  '福州': [119.4543, 25.9222],
  '秦皇岛': [119.2126, 40.0232],
  '绍兴': [120.564, 29.7565],
  '聊城': [115.9167, 36.4032],
  '肇庆': [112.1265, 23.5822],
  '舟山': [122.2559, 30.2234],
  '苏州': [120.6519, 31.3989],
  '莱芜': [117.6526, 36.2714],
  '菏泽': [115.6201, 35.2057],
  '营口': [122.4316, 40.4297],
  '葫芦岛': [120.1575, 40.578],
  '衡水': [115.8838, 37.7161],
  '衢州': [118.6853, 28.8666],
  '西宁': [101.4038, 36.8207],
  '西安': [109.1162, 34.2004],
  '贵阳': [106.6992, 26.7682],
  '连云港': [119.1248, 34.552],
  '邢台': [114.8071, 37.2821],
  '邯郸': [114.4775, 36.535],
  '郑州': [113.4668, 34.6234],
  '鄂尔多斯': [108.9734, 39.2487],
  '重庆': [107.7539, 30.1904],
  '金华': [120.0037, 29.1028],
  '铜川': [109.0393, 35.1947],
  '银川': [106.3586, 38.1775],
  '镇江': [119.4763, 31.9702],
  '长春': [125.8154, 44.2584],
  '长沙': [113.0823, 28.2568],
  '长治': [112.8625, 36.4746],
  '阳泉': [113.4778, 38.0951],
  '青岛': [120.4651, 36.3373],
  '韶关': [113.7964, 24.7028]
};

export const yBarData = [
  {
    linePower:[40, 60, 37, 42, 56, 76, 57, 80],
    firmPower:  [90, 100, 120, 80, 70, 110, 120, 100]
  },
  {
    linePower:[51, 42, 57, 43, 87, 32, 54, 64],
    firmPower:  [100, 97, 138, 89, 64, 121, 134, 124]
  },
  {
    linePower:[67, 65, 78, 54, 55, 58, 52, 63],
    firmPower: [98, 95, 124, 92, 73, 130, 124, 98]
  },
  {
    linePower:[54, 65, 64, 65, 68, 71, 42, 57],
    firmPower:  [82, 99, 129, 87, 91, 130, 120, 100]
  }
]

export const columnData=[
  [
    {
      type: '3月',
      sales: 90,
    },
    {
      type: '4月',
      sales: 100,
    },
    {
      type: '5月',
      sales: 120,
    },
    {
      type: '6月',
      sales: 80,
    },
    {
      type: '7月',
      sales: 70,
    },
    {
      type: '8月',
      sales: 110,
    },
    {
      type: '9月',
      sales: 120,
    },
    {
      type: '10月',
      sales: 100,
    },
  ],
  [
    {
      type: '3月',
      sales: 86,
    },
    {
      type: '4月',
      sales: 121,
    },
    {
      type: '5月',
      sales: 142,
    },
    {
      type: '6月',
      sales: 68,
    },
    {
      type: '7月',
      sales: 87,
    },
    {
      type: '8月',
      sales: 122,
    },
    {
      type: '9月',
      sales: 132,
    },
    {
      type: '10月',
      sales: 101,
    },
  ],
  [
    {
      type: '3月',
      sales: 89,
    },
    {
      type: '4月',
      sales: 121,
    },
    {
      type: '5月',
      sales: 136,
    },
    {
      type: '6月',
      sales: 91,
    },
    {
      type: '7月',
      sales: 84,
    },
    {
      type: '8月',
      sales: 129,
    },
    {
      type: '9月',
      sales: 138,
    },
    {
      type: '10月',
      sales: 99,
    },
  ],
  [
    {
      type: '3月',
      sales: 57,
    },
    {
      type: '4月',
      sales: 87,
    },
    {
      type: '5月',
      sales: 104,
    },
    {
      type: '6月',
      sales: 76,
    },
    {
      type: '7月',
      sales: 68,
    },
    {
      type: '8月',
      sales: 132,
    },
    {
      type: '9月',
      sales: 165,
    },
    {
      type: '10月',
      sales: 125,
    },
  ]
]

export const linePowerData=[
  [
    {
      name: '摊青机',
      value: 45
    },
    {
      name: '计量杀青',
      value: 148
    },
    {
      name: '摊凉回溯',
      value: 9
    },
    {
      name: '揉捻',
      value: 10
    },
    {
      name: '热风模块',
      value: 104
    },
    {
      name: '循环滚炒',
      value: 198
    }
  ],
  [
    {
      name: '摊青机',
      value: 62
    },
    {
      name: '计量杀青',
      value: 175
    },
    {
      name: '摊凉回溯',
      value: 18
    },
    {
      name: '揉捻',
      value: 25
    },
    {
      name: '热风模块',
      value: 154
    },
    {
      name: '循环滚炒',
      value: 251
    }
  ],
  [
    {
      name: '摊青机',
      value: 56
    },
    {
      name: '计量杀青',
      value: 198
    },
    {
      name: '摊凉回溯',
      value: 26
    },
    {
      name: '揉捻',
      value: 35
    },
    {
      name: '热风模块',
      value: 168
    },
    {
      name: '循环滚炒',
      value: 311
    }
  ],
  [
    {
      name: '摊青机',
      value: 54
    },
    {
      name: '计量杀青',
      value: 163
    },
    {
      name: '摊凉回溯',
      value: 14
    },
    {
      name: '揉捻',
      value: 17
    },
    {
      name: '热风模块',
      value: 156
    },
    {
      name: '循环滚炒',
      value: 248
    }
  ]
]

export const pieData = [
  [
    {
      type: '办公室',
      value: 124,
    },
    {
      type: '车间',
      value: 213,
    },
    {
      type: '生产线',
      value: 421,
    },
    {
      type: '门卫室',
      value: 46,
    },
    {
      type: '厨房',
      value: 165,
    },
    {
      type: '其它',
      value: 5,
    },
  ],
  [
    {
      type: '办公室',
      value: 142,
    },
    {
      type: '车间',
      value: 254,
    },
    {
      type: '生产线',
      value: 444,
    },
    {
      type: '门卫室',
      value: 56,
    },
    {
      type: '厨房',
      value: 189,
    },
    {
      type: '其它',
      value: 7,
    },
  ],
  [
    {
      type: '办公室',
      value: 152,
    },
    {
      type: '车间',
      value: 278,
    },
    {
      type: '生产线',
      value: 510,
    },
    {
      type: '门卫室',
      value: 67,
    },
    {
      type: '厨房',
      value: 217,
    },
    {
      type: '其它',
      value: 5,
    },
  ],
  [
    {
      type: '办公室',
      value: 146,
    },
    {
      type: '车间',
      value: 270,
    },
    {
      type: '生产线',
      value: 527,
    },
    {
      type: '门卫室',
      value: 65,
    },
    {
      type: '厨房',
      value: 242,
    },
    {
      type: '其它',
      value: 7,
    },
  ]
]


export const chinaGeoCoordMap = {
  长沙湘丰智能装备股份有限公司: [113.15191258404539, 28.22853168159085],
  陕西天赐秦韵茶业有限公司: [107.0390732318, 33.0752555061],
  湖北羊楼洞茶业有限公司: [113.9005165401, 29.7248395273],
  陕西省商南县金丝茶业发展有限公司: [110.8838797641, 33.5218667634],
  福建省寿宁县龙虎山茶场: [119.5759627771, 27.2305902979],
  湖南保靖黄金茶有限公司: [109.6569674022, 28.6983749843],
  福建省清流县苏福茶业有限公司: [117.0614977717, 26.2919440694],
  贵州省勇创农牧科技公司: [109.1620468969, 27.6690024693],
  陕西新巢茶叶股份有限公司: [107.7666936975, 32.9830564607],
  四川林湖茶业有限公司: [104.6416999259, 28.7513048719],
  湖北金莓科技发展有限公司: [113.1661520979, 30.6634018438],
  湖南壶瓶山茶业有限公司: [111.6985030743, 29.0316187528],
  新疆阿勒泰戈宝麻有限公司: [88.140237252, 47.8456515899],
  广南县凯鑫生态茶业开发有限公司: [105.0551540856, 24.0464361489],
  湖北水镜茶业发展有限公司: [111.8390214772, 31.7747357006],
  山东临沂山松药业有限公司: [118.3564391517, 35.104625063],
  福建省翠云茶业有限公司: [117.6391791967, 26.2639244533],
  湖南省辰州碣滩茶业有限公司: [113.0148264301, 25.7706002612],
  浙江松阳县农业局: [119.4820355963, 28.4494291035],
  福建省农业科学院茶叶研究所: [119.2964598587, 26.0741734513],
  澧县太靑山有机食品有限公司: [111.6985030743, 29.0316187528],
  长沙县金井茶厂: [113.0809011682, 28.2460116845],
  安化万隆实业有限公司: [112.3551413208, 28.553910293],
  武汉黄鹤楼茶叶有限公司茶叶: [114.3052306105, 30.5927473203],
  泰宁县泰和生态茶有限公司: [117.1757990993, 26.9001252998],
  福建一笔峰茶业有限公司: [116.6544070729, 26.2617705953],
  青岛瑯琊海青茶发展有限公司: [120.382958831, 36.0662525076],
  吉首市新田农业科技开发有限公司: [109.6981120319, 28.2623878439],
  重庆市二圣茶业有限公司: [106.5507444657, 29.5647049443],
  湖南舜源野生茶业有限公司: [113.0148264301, 25.7706002612],
  湖北金果茶业有限公司: [109.4791727865, 30.2951370649],
  湖南湘丰茶业有限公司: [113.0809011682, 28.2460116845],
  宜昌高山云雾茶业专用合作社: [111.2864076321, 30.6918470497],
  宜昌鸿渐茶业有限公司: [111.2864076321, 30.6918470497],
  重庆市九锅箐农林综合开发有限责任公司: [106.5507444657, 29.5647049443]
}

export const chinaDatas = [
  [{
    name: '长沙湘丰智能装备股份有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '陕西天赐秦韵茶业有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '湖北羊楼洞茶业有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '陕西省商南县金丝茶业发展有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '福建省寿宁县龙虎山茶场',
    value: 0,
    num: 1
  }],
  [{
    name: '湖南保靖黄金茶有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '福建省清流县苏福茶业有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '贵州省勇创农牧科技公司',
    value: 0,
    num: 1
  }],
  [{
    name: '陕西新巢茶叶股份有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '四川林湖茶业有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '湖北金莓科技发展有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '湖南壶瓶山茶业有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '新疆阿勒泰戈宝麻有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '广南县凯鑫生态茶业开发有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '湖北水镜茶业发展有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '山东临沂山松药业有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '福建省翠云茶业有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '湖南省辰州碣滩茶业有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '浙江松阳县农业局',
    value: 0,
    num: 1
  }],
  [{
    name: '福建省农业科学院茶叶研究所',
    value: 0,
    num: 1
  }],
  [{
    name: '澧县太靑山有机食品有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '长沙县金井茶厂',
    value: 0,
    num: 1
  }],
  [{
    name: '安化万隆实业有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '武汉黄鹤楼茶叶有限公司茶叶',
    value: 0,
    num: 1
  }],
  [{
    name: '泰宁县泰和生态茶有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '福建一笔峰茶业有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '青岛瑯琊海青茶发展有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '吉首市新田农业科技开发有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '重庆市二圣茶业有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '湖南舜源野生茶业有限公司',
    value: 0,
    num: 1
  }],

  [{
    name: '湖北金果茶业有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '湖南湘丰茶业有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '宜昌高山云雾茶业专用合作社',
    value: 0,
    num: 1
  }],
  [{
    name: '宜昌鸿渐茶业有限公司',
    value: 0,
    num: 1
  }],
  [{
    name: '重庆市九锅箐农林综合开发有限责任公司',
    value: 0,
    num: 1
  }]
]

export const chartDatas = [
  {
    // 条形图
    type: 'v-chart',
    title: '设备进茶与出茶重量比',
    id: 1,
    data: {
      chartSettings: {
        type: 'bar'
      },
      chartData: {
        columns: ['设备名', '进茶', '出茶', '出茶率'],
        rows: [
          { 设备名: '摊青机', 进茶: 1393, 出茶: 1093, 出茶率: 0.32 },
          { 设备名: '计量杀青', 进茶: 3530, 出茶: 3230, 出茶率: 0.26 },
          { 设备名: '摊凉回潮', 进茶: 2923, 出茶: 2623, 出茶率: 0.76 },
          { 设备名: '揉捻机', 进茶: 1723, 出茶: 1423, 出茶率: 0.49 },
          { 设备名: '热风解块', 进茶: 3792, 出茶: 3492, 出茶率: 0.323 }
        ]
      }
    }
  },
  //{id:2},
  {
    // 条形图
    type: 'v-model',
    title: '揉捻模块',
    id: 3,
    data: {
      chartSettings: {
        type: 'bar'
      },
      chartData: {
        columns: ['日期', '访问用户', '下单用户', '下单率'],
        rows: [
          { 日期: '1/1', 访问用户: 1393, 下单用户: 1093, 下单率: 0.32 },
          { 日期: '1/2', 访问用户: 3530, 下单用户: 3230, 下单率: 0.26 },
          { 日期: '1/3', 访问用户: 2923, 下单用户: 2623, 下单率: 0.76 },
          { 日期: '1/4', 访问用户: 1723, 下单用户: 1423, 下单率: 0.49 },
          { 日期: '1/5', 访问用户: 3792, 下单用户: 3492, 下单率: 0.323 },
          { 日期: '1/6', 访问用户: 4593, 下单用户: 4293, 下单率: 0.78 }
        ]
      }
    }
  },
  {
    // 图表模块
    type: 'v-chart',
    title: '当前生产线与去年同期产量对比',
    id: 4,
    data: {
      chartSettings: {
        // 设置图表类型
        type: 'histogram'
      },
      chartData: {
        columns: ['月份', '去年同期产量', '当前产量'],
        rows: [
          { 月份: '5月', 去年同期产量: 1293, 当前产量: 1693 },
          { 月份: '6月', 去年同期产量: 3530, 当前产量: 3930 },
          { 月份: '7月', 去年同期产量: 2923, 当前产量: 3623 },
          { 月份: '8月', 去年同期产量: 1723, 当前产量: 2423 },
          { 月份: '9月', 去年同期产量: 3792, 当前产量: 4492 }
        ]
      }
    }
  },
  //{id: 5},
  {
    // 病虫害防治模块
    type: 'v-pest',
    title: '病虫害防治平台',
    id: 6,
    data: {
      url: 'http://pest.cs-xf.com:9000/imagedata/',
      images: [
        {
          path: '2023/10/17/066aff363136535243183310-1697505173793.jpg',
          name: '古茶园'
        },
        {
          path: '2023/10/17/066aff363136535243183310-1697508795371.jpg',
          name: '幼茶园'
        },
        {
          path: '2023/10/15/066bff363136535243183245-1697331959938.jpg',
          name: '飞跃基地'
        },
        {
          path: '2023/10/15/066bff363136535243183245-1697336246519.jpg',
          name: '古茶园'
        },
        {
          path: '2023/10/15/066bff363136535243183243-1697335539882.jpg',
          name: '飞跃基地'
        },
        {
          path: '2023/10/15/066bff363136535243183243-1697336326931.jpg',
          name: '幼茶园'
        }
      ]
    }
  },
  {
    // 条形图
    type: 'v-chart',
    title: '设备能耗',
    id: 7,
    data: {
      colorChange: true,
      chartSettings: {
        type: 'bar'
      },
      chartData: {
        columns: ['设备名', '设备能耗'],
        rows: [
          { 设备名: '摊青机', 设备能耗: 1393 },
          { 设备名: '计量杀青', 设备能耗: 3530 },
          { 设备名: '摊凉回潮', 设备能耗: 2923 },
          { 设备名: '揉捻机', 设备能耗: 1723 },
          { 设备名: '热风解块', 设备能耗: 3792 }
        ]
      }
    }
  },
  {
    // 柱状图
    type: 'v-chart',
    title: '当前生产线月产量',
    id: 8,
    // templateStyle: 'display:flex;justify-content: center;',
    templateStyle: {
      display: 'flex',
      justifyContent: 'center'
    },
    data: {
      colorChange: true,
      chartSettings: {
        type: 'histogram'
      },
      chartData: {
        columns: ['月份', '当前产量'],
        rows: [
          { 月份: '1月', 当前产量: 693 },
          { 月份: '2月', 当前产量: 2930 },
          { 月份: '3月', 当前产量: 1693 },
          { 月份: '4月', 当前产量: 3930 },
          { 月份: '5月', 当前产量: 3693 },
          { 月份: '6月', 当前产量: 930 },
          { 月份: '7月', 当前产量: 5623 },
          { 月份: '8月', 当前产量: 1423 },
          { 月份: '9月', 当前产量: 492 },
          { 月份: '10月', 当前产量: 1293 },
          { 月份: '11月', 当前产量: 3130 },
          { 月份: '12月', 当前产量: 2223 }
        ]
      }
    }
  },
  {
    // 柱状图
    type: 'v-surveillance',
    title: '茶园监控',
    id: 9,
    data: {
      url: 'http://pest.cs-xf.com:9000/imagedata/',
      images: [
        {
          path: '2023/10/17/066aff363136535243183310-1697505173793.jpg',
          name: '古茶园'
        },
        {
          path: '2023/10/17/066aff363136535243183310-1697508795371.jpg',
          name: '幼茶园'
        },
        {
          path: '2023/10/15/066bff363136535243183245-1697331959938.jpg',
          name: '飞跃基地'
        },
        {
          path: '2023/10/15/066bff363136535243183245-1697336246519.jpg',
          name: '古茶园'
        },
        {
          path: '2023/10/15/066bff363136535243183243-1697335539882.jpg',
          name: '飞跃基地'
        },
        {
          path: '2023/10/15/066bff363136535243183243-1697336326931.jpg',
          name: '幼茶园'
        }
      ]
    }
  }
]

